import React from "react"
import PropTypes from "prop-types"

const ArrowLeft = ({ fillColor }) => (
  <svg
    width="28"
    height="10"
    viewBox="0 0 28 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.575735 5.42426C0.341421 5.18995 0.341421 4.81005 0.575735 4.57574L4.39411 0.757359C4.62843 0.523045 5.00833 0.523045 5.24264 0.757359C5.47696 0.991674 5.47696 1.37157 5.24264 1.60589L1.84853 5L5.24264 8.39411C5.47696 8.62843 5.47696 9.00833 5.24264 9.24264C5.00833 9.47696 4.62843 9.47696 4.39411 9.24264L0.575735 5.42426ZM27.5 5.6H1V4.4H27.5V5.6Z"
      fill={fillColor}
    />
  </svg>
)

ArrowLeft.propsTypes = {
  fillColor: PropTypes.string,
}

ArrowLeft.defaultProps = {
  fillColor: "#414141",
}

export { ArrowLeft }
